/* Builder-only batch submission; Shopify prices items and selection remains in the DOM. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (storefront.ncrBuilderCart) return;
  // Retain only this root's pending state across disposal/remount. Never retry adds.
  const submissions = new WeakMap();

  storefront.ncrBuilderCart = {
    unregister: storefront.lifecycle.register('ncr-builder-cart', '[data-bs-builder-selection]', function(section) {
      const root = section.querySelector('.builder-rows');
      const atcBtn = section.querySelector('.builder-atc-btn');
      const statusEl = section.querySelector('.builder-status');
      if (!root || !atcBtn) return;
      const cartProperty = section.dataset.cartProperty || 'Costume Build';
      const buildName = section.dataset.buildName || '';
      const includeBuildPdf = section.dataset.buildPdfEnabled === 'true';
      const buildPdfVariantId = Number(section.dataset.buildPdfVariantId) || null;
      const localeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      const cartAddUrl = localeRoot ? localeRoot + 'cart/add.js' : '/cart/add.js';
      const cartViewUrl = localeRoot ? localeRoot + 'cart' : '/cart';
      let disposed = false;
      let state = submissions.get(section);
      if (!state) {
        state = { pending: false, redirecting: false, message: '', error: false, view: null, timer: null };
        submissions.set(section, state);
      }
      function render() {
        atcBtn.disabled = state.pending || state.redirecting;
        atcBtn.setAttribute('aria-disabled', String(atcBtn.disabled));
        atcBtn.setAttribute('aria-busy', String(state.pending));
        if (statusEl) {
          statusEl.textContent = state.message;
          statusEl.classList.toggle('is-error', state.error);
        }
      }
      state.view = render;
      function setStatus(message, error) {
        state.message = message;
        state.error = !!error;
        if (state.view) state.view();
      }
      // Build ID stamped on every line item from this submission so fulfillment can group them.
      function generateBuildId() {
        const slug = (buildName || 'BUILD')
          .toUpperCase()
          .replace(/[^A-Z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '') || 'BUILD';
        return slug + '-' + Date.now();
      }


      async function submit() {
        if (disposed || state.pending || state.redirecting) return;
        const items = [];
        const skipped = [];
        const buildId = generateBuildId();
        Array.from(root.querySelectorAll('.builder-row')).forEach(function(row) {
          const include = row.querySelector('.builder-include-input');
          if (!include || !include.checked) return;
          const active = row.querySelector('.builder-finish-btn.is-active');
          if (!active) return;
          // Never try to add a sold-out variant — even if somehow it became the active one.
          if (active.dataset.variantAvailable === 'false') {
            const name = (row.querySelector('.builder-row-title') || {}).textContent || 'a piece';
            skipped.push(name.trim());
            return;
          }
          const variantId = Number(active.dataset.variantId);
          if (!variantId) return;
          const pieceName = (row.querySelector('.builder-row-title') || {}).textContent || '';
          const finishLabel = active.dataset.finishLabel || '';
          const properties = {};
          if (buildName) properties[cartProperty] = buildName;
          if (pieceName) properties['Piece'] = pieceName.trim();
          if (finishLabel) properties['Finish'] = finishLabel;
          properties['Build ID'] = buildId;
          items.push({ id: variantId, quantity: 1, properties: properties });
        });

        // Append the digital build PDF as its own line item so Digital Downloads can deliver it.
        // Skipped when no physical pieces were selected (no build = no guide).
        if (includeBuildPdf && buildPdfVariantId && items.length) {
          const pdfProperties = {};
          if (buildName) pdfProperties[cartProperty] = buildName;
          pdfProperties['Build ID'] = buildId;
          pdfProperties['Digital Item'] = 'Build PDF';
          pdfProperties['Included With'] = 'Costume Build';
          items.push({
            id: Number(buildPdfVariantId),
            quantity: 1,
            properties: pdfProperties
          });
        }

        if (skipped.length) {
          setStatus('Sold out: ' + skipped.join(', ') + '. Pick another finish or uncheck.', true);
          return;
        }

        if (!items.length) {
          setStatus('Select at least one piece to add to cart.', true);
          return;
        }


        state.pending = true;
        setStatus('Adding to cart\u2026', false);
        try {
          const res = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (res.ok) {
            // Preserve the existing HTTP-success contract. No second cart mutation.
            state.pending = false;
            state.redirecting = !!state.view;
            setStatus(state.view ? 'Added to cart. Redirecting\u2026' : 'Added to cart.', false);
            if (state.view) {
              state.timer = setTimeout(function() {
                state.timer = null;
                state.redirecting = false;
                setStatus('Added to cart.', false);
                if (state.view) window.location.href = cartViewUrl;
              }, 500);
            }
          } else {
            let message = 'Could not add to cart.';
            try {
              const data = await res.json();
              if (data && typeof (data.description || data.message) === 'string') message = data.description || data.message;
            } catch (error) { /* preserve generic HTTP error when JSON is unavailable */ }
            state.pending = false;
            setStatus(message + ' Check your cart before trying again.', true);
          }
        } catch (error) {
          state.pending = false;
          setStatus('Network error while adding to cart. Some items may already have been added. Check your cart before trying again.', true);
        }
      }
      atcBtn.addEventListener('click', submit);
      render();
      return function dispose() {
        disposed = true;
        atcBtn.removeEventListener('click', submit);
        state.view = null;
        if (state.timer !== null) {
          clearTimeout(state.timer);
          state.timer = null;
          state.redirecting = false;
          state.message = 'Added to cart.';
        }
        // Do not abort, retry or roll back a non-idempotent request on removal.
      };
    })
  };
})();
